<template>
  <CCard>
    <CCardBody>
      <CCardHeader>
        <CRow>
          <CCol col="8" style="text-align: start">
            <strong v-if="docType==3">{{ $t('receiveCashDoc') }}</strong>
            <strong v-if="docType==1">{{ $t('payCashDoc') }}</strong>
          </CCol>
          <CCol col="4" style="text-align: end">
            <CSelect v-if="show_doc_type" :options="[
                {label:$t('sidebars.payOperation'),value:1},
                {label:$t('sidebars.receiveOperation'),value:3}
              ]"

                     @change="changePayReceiveType"
                     :value="docType" />
            <CButton v-if="status_form==0 && !is_year_closed()" class="mr-1 ml-1" @click="insert_data_cash()"
                     type="submit" size="sm"
                     color="secondary">
              {{ $t('buttons.save') }}
            </CButton>

            <CButton v-if="status_form==0 && is_year_closed()" class="mr-1 ml-1"
                     @click="year_closed_dialog()"
                     size="sm"
                     color="danger">
              {{ $t('buttons.save') }}
            </CButton>

          </CCol>
        </CRow>
        <!--        </div>-->

        <!-- Right aligned nav items -->
        <!--      </CCollapse>-->
      </CCardHeader>

      <CRow>

        <CCol col="4">
          <CRow form class="form-group">
            <CCol tag="label" v-if="docType==3" sm="4" class="col-form-label">
              {{ $t('components.receiveDate') }}
            </CCol>
            <CCol tag="label" v-if="docType==1" sm="4" class="col-form-label">
              {{ $t('components.payDate') }}
            </CCol>
            <CCol sm="8">
              <date-picker
                  v-model="date_cash"
                  v-if="!get_access('hyper_sale')"
                  :min="get_min_doc_date()"
                  :max="get_max_doc_date()"
              ></date-picker>

            </CCol>
          </CRow>

        </CCol>
        <CCol col="3" v-if="docType==3">مانده فاکتور: {{ get_currency(remaining_invoice) }}</CCol>
        <CCol col="3" v-if="docType==1">مانده فاکتور: {{ get_currency(remaining_invoice*-1) }}</CCol>
        <CCol col="3" v-if="docType==1">مانده مشتری: {{ get_currency(remaining_person*-1) }}</CCol>
        <CCol col="3" v-if="docType==3">مانده مشتری: {{ get_currency(remaining_person) }}</CCol>

      </CRow>

      <CRow>
        <CCol col="12" class="mb-3">

          <CDataTableFixed
              :items="items_receive_cash"
              :fields="fields_receive_cash"
              striped
              border
              height="300px"
              :items-per-page="200"
              hover
              pagination
          >

            <template #pay_for="{item}">
              <td>
                <CInput
                    :placeholder="$t('description')"
                    v-model="item.summary"
                />
              </td>
            </template>
            <template #resource="{item,index}">
              <td>
                <CRow class="m-0">
                  <CCol col="3" class="p-0">
                    <CSelect
                        :options="doc_types"
                        :value.sync="item.selected_doc_type"
                    />

                  </CCol>
                  <CCol col="9" class="p-0">
                    <CSelectDefaultValue
                      v-if="item.selected_doc_type!=-1"
                             :options="payer_items_data.filter(x=>x.doc_type==item.selected_doc_type)"
                             :value.sync="item.selected_receiver_cash"

                    />
                    <CInput v-if="item.selected_doc_type==-1 "
                            type="number"
                            v-on:keypress="isNumber($event)"
                            v-model="item.serial"
                            :placeholder="$t('chequeNumber')"
                    />
                  </CCol>
                  <CCol col="12" class="p-0" v-if="item.selected_doc_type==-1">
                    <CRow>
                      <CCol col="6">
                        <date-picker
                            v-model="item.pass_date"
                            :placeholder="$t('components.passDate')"
                        ></date-picker>
                      </CCol>
                      <CCol col="6">
                        <CSelect style="margin-bottom: 1rem"
                                 :options="bank_names"
                                 :value.sync="item.bank_name"
                                 :placeholder="$t('bankName')"

                        />
                      </CCol>
                      <CCol col="6">
                        <CInput
                            v-model="item.sort_code"
                            :maxlength="6"
                            :placeholder="$t('sortCode')"

                        />
                      </CCol>
                      <CCol col="6">
                        <CInput
                            :maxlength="8"
                            v-model="item.bank_no"
                            :placeholder="$t('AccountNo')"
                        />
                      </CCol>

                    </CRow>

                  </CCol>
                </CRow>
              </td>
            </template>

            <template #amount="{item}">

              <td>
                <CInputCurrency
                    v-model="item.amount"
                />
              </td>

            </template>

            <template #operation="{item,index}">
              <td>
                <CButton
                    class="mr-1"
                    size="sm"
                    @click="items_receive_cash.splice(index, 0, {selected_master_type:80,selected_doc_type:70})"
                    color="dark"
                >
                  <CIcon size="sm" name="cil-plus"></CIcon>
                </CButton>
                <CButton v-if="items_receive_cash.length>1"
                         class="mr-1"
                         size="sm"
                         @click="items_receive_cash.splice(index,1)"
                         color="primary"
                >
                  <CIcon size="sm" name="cil-minus"></CIcon>
                </CButton>
              </td>

            </template>


          </CDataTableFixed>

        </CCol>

        <CCol style="float: right">
          {{ $t('totalSum') }} : {{ get_currency(cash_total) }}
        </CCol>
      </CRow>


    </CCardBody>
    <CModal
        color="dark"
        size="lg"
        :show.sync="invoice_info"
    >
      <CDataTableFixed
          :items="items_invoice"
          :fields="fields_invoice"
          :items-per-page="200"
          hover

          border
          striped

      >
        <template #row="{item,index}">

          <td>
            <p class="text-center">{{ index + 1 }}</p>

          </td>

        </template>
        <template #docDate="{item}">

          <td>
            <p class="text-center">{{ get_date(item.docDate) }}</p>

          </td>

        </template>

        <template #balance="{item}">
          <td>
            <!--                  <p v-if="item.amount>item.amountNegetive" style="text-align:right">{{ get_currency(item.accBalance) }}</p>-->
            <!--                  <p v-else style="text-align:right">{{ get_currency(item.accBalanceNegetive) }}</p>-->
            <p class="text-right text-danger" v-if="item.balance<0">{{ get_currency(Math.abs(item.balance)) }}</p>
            <p class="text-right" v-else>{{ get_currency(item.balance) }}</p>

          </td>
        </template>

        <template #amount="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amount) }}</p>
          </td>
        </template>
        <template #amountNegetive="{item}">
          <td>
            <p class="text-right">{{ get_currency(item.amountNegetive) }}</p>
          </td>
        </template>
        <template #partyName="{item}">

          <td>
            <p>{{ item.partyName }}</p>

          </td>

        </template>
        <template #toziKonande="{item}">

          <td>
            <p v-if="item.toziKonande!=null">{{ item.toziKonande }}</p>

          </td>

        </template>
        <template #user="{item}">
          <td>
            <p>{{ item.createdBy }}</p>
          </td>
        </template>
        <template #masterCode="{item}">
          <td>
            <p class="text-center">{{ item.masterCode }}</p>
          </td>
        </template>


        <template #operation="{item}">
          <td>

            <CButton v-if="item.statusId ==0"

                     size="sm"
                     :title="$t('buttons.finalize')"
                     @click="Finalize(item)"
            >
              <CIcon name="cil-trash" class="text-danger"/>
            </CButton>


          </td>
        </template>

        <template #under-table>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol>{{ $t('totalCirculation') }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amountNegetive')) }}</CCol>
            <CCol>{{ get_currency(calculate_items(items_invoice, 'amount')) }}</CCol>

          </CRow>
          <CRow>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol></CCol>
            <CCol class="bg-dark">{{ $t('tables.balance') }}</CCol>
            <CCol class="bg-dark text-danger" v-if="calculate_items(items_invoice,'amountNegetive')
                - calculate_items(items_invoice,'amount')<0">{{
                get_currency(Math.abs(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount')))
              }}
            </CCol>
            <CCol class="bg-dark" v-else>{{
                get_currency(calculate_items(items_invoice, 'amountNegetive')
                    - calculate_items(items_invoice, 'amount'))
              }}
            </CCol>
            <CCol></CCol>

          </CRow>

        </template>

      </CDataTableFixed>

      <template #footer>
        <CButton @click="invoice_info = false" color="danger">{{ $t('buttons.close') }}</CButton>
      </template>
    </CModal>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import moment from 'moment-jalaali'
import Vue from "vue";

var simulateAsync = null
const simulateAsyncOperation = fn => {
  if (simulateAsync != null) {
    clearTimeout(simulateAsync)
  }
  simulateAsync = setTimeout(fn, 1000)
}
export default {
  name: 'ReceiveOperation',

  components: {
    Treeselect,
    BTabs,
  },

  data() {
    var self = this;

    return {
      pos_id:306,
      selected_focus_reference: null,
      items_invoice: [],
      search_master_type: null,
      payer_items_data:[],

      fields_invoice: [
        {key: 'row', label: this.$t('tables.sharp'), sorter: false, _style: 'width:2%;text-align:center'},
        {key: 'docDate', label: this.$t('tables.date'), _style: 'width:10%'},
        {key: 'statusTitle', label: this.$t('tables.documentType'), _style: 'width:10%'},
        {key: 'accNo', label: this.$t('docNumber'), _style: 'width:10%'},
        {key: 'masterCode', label: this.$t('referenceNo'), _style: 'width:10%'},

        {key: 'amountNegetive', label: this.$t('bedehkar'), _style: 'width:10%'},
        {key: 'amount', label: this.$t('bestankar'), _style: 'width:10%'},

        {key: 'balance', label: this.$t('tables.balance'), _style: 'width:10%'},

      ],

      // selected_master_type: 80,
      invoice_info: false,
      selected_index_table: 0,
      search_reference_master: 0,
      selected_doc_type: 70,
      selected_receiver_cash: 0,
      document_person_cash: null,
      searched_refrences: [],
      get_items: [1],
      master_id: null,

      master_types: [

      ],
      active_tab: 0,
      date_cash: '',
      summary: '',
      cashiers: [],
      banks: [],
      terminals: [],
      selected_payer_cash: null,
      selected_payer_cash_text: '',
      doc_types: [
        {value: 70, label: this.$t('components.cash')},
        {
          value: 74, label: this.$t('components.bank')
        },
        {value: this.pos_id, label: this.$t('components.pos')},
        {value: 288, label: this.$t('onTheWay')},
        {value: 231, label: this.$t('tables.off')},
        {value: -1, label: this.$t('cheque')},

      ],
      status_form: 0,
      price: '',
      bank_names: [],
      searched_person: [],
      document_person: null,
      search_user_async: true,

      normalizer_persons(node) {
        return {
          id: node.userName + " " + node.surName,
          label: node.userName + " " + node.surName,
        }
      },


      normalizer_refrence(node) {
        return {
          id: node.factorMasterId,
          label: node.masterCode,
        }
      },
      normalizer_documents(node) {
        return {
          id: node.id,
          label: node.label,
        }
      },
      normalizer_tafsili(node) {
        return {
          id: node.recId,
          label: node.recTitle,
        }
      },


      items: [],
      selected_master_type_item: 0,
      fields_receive_cash: [
        // {key: 'row', label: "No.", _style: 'width:2%;padding:0px'},

        // {key: 'payer', label: this.$t('creditSide'), _style: 'width:15%;padding:0px'},
        {key: 'resource', label: this.$t('components.docType'), _style: 'width:30%;padding:0px'},

        {key: 'amount', label: this.$t('tables.amount'), _style: 'width:15%;padding:0px'},

        {key: 'pay_for', label: this.$t('tables.payFor'), _style: 'width:15%;padding:0px'},

        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;padding:0px'},
      ],
      items_receive_cash: [{selected_master_type: 80, selected_doc_type: 70}],
      // tafsili_list: [],
      selected_tafsili: null,
      remaining_person: '',
      remaining_invoice: '',
    }
  },
  mounted() {
    if(this.$i18n.locale=="fa"){
      this.pos_id = 77
    }
    this.master_types= [
      {value: 163, label: this.$t('Suppliers')},
      {value: 80, label: this.$t('Customers')},
      {value: 92, label: this.$t('persons')},
      {value: 91, label: this.$t('components.employee')},
      {value: 70, label: this.$t('components.cash')},
      {value: 74, label: this.$t('components.bank')},
      {value: this.pos_id, label: this.$t('components.pos')},
      {value: 288, label: this.$t('collector')},
      {value: 0, label: this.$t('Other')},
    ];

        this.doc_types= [
      {value: 70, label: this.$t('components.cash')},
      {value: 74, label: this.$t('components.bank')},
      {value: this.pos_id, label: this.$t('components.pos')},
      {value: 288, label: this.$t('onTheWay')},
      {value: 231, label: this.$t('tables.off')},
      {value: -1, label: this.$t('cheque')},

    ];
        if(this.docType==1){
          this.doc_types[4].value = 100
        }

        // this.select_moein(this.items_receive_cash[0], 0)
    this.date_cash = this.get_today();

    // this.$root.root_validate_errors = [];
// this.$root.header_action.innerHTML = this.$refs['action_bar'].innerHTML
    this.get_banks();
    // this.get_bank_names();
    // this.get_cashiers();
    // this.get_terminals();

    this.get_person_remaining_amount(this.partyId)
    this.get_invoice_remaining(this.factorMasterId);
    // this.select_moein();


    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
    }
  },
  watch: {
    'items_receive_cash': function () {
      console.log("watch called")
      this.items_receive_cash.forEach(function (val) {
        if (val.amount == ".") {
          val.amount = "0."
        }
      });


    }
  },
  computed: {

    cash_total() {
      var total = 0;
      this.items_receive_cash.forEach((val) => {
        if (val.amount != null) {
          total += parseFloat(val.amount);

        }
      });
      return total;
    },

    payfor_items() {
      var items = [];

      return items;
    },
  },
  props: {
    partyId: Number,
    partyName: String,
    factorMasterId: String,
    selectedMasterType: Number,
    show_doc_type: {Type:Boolean,Default:false},
    docType: Number,
  },
  methods: {
    changePayReceiveType(e){
      console.log("e.target.value",e.target.value)
      this.$emit('update:docType', e.target.value, e.target.value)

    },
    payer_items(doc_type, index) {
      var items = [];
      if (doc_type == 70) {
        this.cashiers.filter(x => x.accountId == 70).forEach((val) => {
          var obj = {label: val.boxTitle, value: val.id}
          items.push(obj)
        });
      }
      if (doc_type == 288) {
        this.cashiers.filter(x => x.accountId == 288).forEach((val) => {
          var obj = {label: val.boxTitle, value: val.id}
          items.push(obj)
        });
      }
      if (doc_type == 74) {
        this.banks.forEach((val) => {
          var obj = {label: val.bankAccTitle, value: val.id}
          items.push(obj)
        });
      }
      if (doc_type == this.pos_id) {
        this.terminals.forEach((val) => {
          var obj = {label: val.terminalTitle, value: val.id}
          items.push(obj)
        });
      }
      // if (items.length > 0) {
      //   this.selected_receiver_cash = items[0].value;
      // }
      if (items.length > 0) {
        if (index != -1) {
          Vue.set(this.items_receive_cash[index], 'selected_receiver_cash', items[0].value);

        } else {
          this.selected_receiver_cash = items[0].value
        }
      }
      return items;
    },


    empty_form() {
      this.items_receive_cash = [{selected_master_type: 80}];
      this.selected_payer_cash = null;
    },

    select_moein(item, index) {
      var self = this;

      const formData = new FormData();
      var url = "GetAccTafsilisByAccountId";
      formData.append("accId", item.selected_master_type);

      // formData.append("accId", this.selected_master_type);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              // item.tafzili_list = response.data.data;
              // item.tafsili_list = response.data.data;
              Vue.set(item, "tafsili_list", response.data.data);
              if (item.tafsili_list.length > 0) {
                item.selected_tafsili = item.tafsili_list[0].value;

              } else {
                self.selected_tafsili = null;

              }
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },

// 222800 16 3 26 4

    add_master_to_search(item) {
      this.search_reference_master = item.document_person
      this.search_master_type = item.selected_master_type
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];


      return true;
      // e.preventDefault();
    },
    validateFormCash: function () {
      this.$root.root_validate_errors = [];

      // if (this.items_receive_cash[0].document_refrence == null || this.items_receive_cash[0].amount == null || this.items_receive_cash[0].amount == "") {
      //   return false;
      // }

      for (var i = 0; i < this.items_receive_cash.length; i++) {
        if (this.items_receive_cash[i].document_person != null) {
          if (this.items_receive_cash[i].amount == "" || this.items_receive_cash[i].amount == null) {
            this.$root.root_validate_errors.push(this.$t('Insert Amount'));

          }
        }
      }
      return true;
      // e.preventDefault();
    },
    insert_data_cheque() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.docType==3) {
        url = "AddReceiverCheque";
      } else {
        url = "AddFactorPayCheque";
        formData.append('id', this.status_form)

      }
      // var master = {
      //   PaymentTypeId: this.selected_doc_type, AccountTypeId: 1, CashierId: this.selected_receiver_cash,
      //   PayerId: this.selected_payer_cash, DocDate: this.date_cash
      // };

      var details = [];

      for (var i = 0; i < this.items_receive_cash.filter(x=>x.selected_doc_type==-1).length; i++) {
        if (
            this.items_receive_cash[i].amount != "" &&
            this.items_receive_cash[i].serial != "" &&
            this.items_receive_cash[i].pass_date != "" &&
            this.items_receive_cash[i].amount != null &&
            this.items_receive_cash[i].amount != "0") {
          if (this.items_receive_cash[i].sort_code.length != 6) {
            this.$root.root_validate_errors.push("Sort Code is 6 Characters");
            return
          }
          if (this.items_receive_cash[i].bank_no.length != 8) {
            this.$root.root_validate_errors.push("Account Code is 8 Characters");
            return
          }
          var factor_master_id = 0;
          var party_id = this.items_receive_cash[i].selected_tafsili

          if (this.items_receive_cash[i].document_person != null) {
            factor_master_id = this.items_receive_cash[i].document_refrence.factorMasterId
            party_id = this.items_receive_cash[i].document_person

          }
          var obj = {
            SarRecidDate: this.items_receive_cash[i].pass_date,
            DocDate: this.date_cash,
            // PartyId: party_id,
            Summary: this.items_receive_cash[i].summary,
            MasterId: self.factorMasterId,
            Price: this.items_receive_cash[i].amount,
            Serial: this.items_receive_cash[i].serial,
            BankId: this.items_receive_cash[i].bank_name,
            SortCode: this.items_receive_cash[i].sort_code,
            BankAccount: this.items_receive_cash[i].bank_no,

            PayerId: this.partyId,
            // PartyAccountId: this.items_receive_cash[i].selected_master_type,
            PartyId: self.partyId,


            DocMasterId: self.factorMasterId,

            PartyAccountId: this.selectedMasterType,

            BranchId: 0,
            MasterType: 1,
          };
          if (obj.PartyAccountId == 0) {
            obj.PartyAccountId = this.items_receive_cash[i].tafsili_list
                .filter(x => x.recId == this.items_receive_cash[i].selected_tafsili)[0].accountId
          }
          if (obj.PayerId == null) {
            obj.PayerId = this.selected_payer_cash_text;
          }
          if (obj.BankId == null) {
            obj.BankId = this.bank_names[0].value;
          }
          if (obj.MasterType == null) {
            obj.MasterType = 1;
          }
          // if (obj.MasterId == null) {
          //   obj.DocMasterId = 0;
          // }
          details.push(obj)
        }
      }
      if(details.length==0){
        return false;
      }
      var send_obj = {Cheques: details}
      console.log(JSON.stringify(send_obj))
      formData.append('model', JSON.stringify(send_obj));

      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        if (res.data.statusCode == 0) {
          self.document_person_cheque = null;
          self.selected_payer_cash_text = "";
          self.items_receive_cash = [{}];
          bus.$emit("update_add_receive", "");

          self.$root.modal_component.show_api_response_modals(res);

        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data_cash() {
      let self = this;

      if(this.get_access('hyper_sale')){
        if(this.remaining_invoice<this.cash_total){
          this.$root.root_validate_errors.push("مبلغ بیش از مانده فاکتور است");

          return false
        }
      }
      this.insert_data_cheque();
      if (!this.validateFormCash()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddCashPayment_New";
      } else {
        url = "EditCashPayment";
        formData.append('id', this.status_form)

      }
      var master = {
        PaymentTypeId: this.selected_doc_type, AccountTypeId: 1,
        PayerId: this.partyId, DocDate: this.date_cash
      };

      var details = [];
      for (var i = 0; i < this.items_receive_cash.filter(x=>x.selected_doc_type!=-1).length; i++) {
        if (this.items_receive_cash[i].amount != "" &&
            this.items_receive_cash[i].amount != null &&
            this.items_receive_cash[i].amount != "0") {

          // var factor_master_id = 0;
          // var party_id = this.items_receive_cash[i].selected_tafsili


          var obj = {
            PartyId: self.partyId,
            DocMasterId: self.factorMasterId,
            MasterType: this.items_receive_cash[i].master_type,
            PayDesc: this.items_receive_cash[i].summary,
            PartyAccountId: this.selectedMasterType,
            PaymentTypeId: this.items_receive_cash[i].selected_doc_type,
            CashierId: this.items_receive_cash[i].selected_receiver_cash,
            Amount: parseFloat(this.items_receive_cash[i].amount)
          };
          if(this.docType==1){
            obj.Amount = obj.Amount*-1
          }
          // if (obj.PartyAccountId == 0) {
          //   obj.PartyAccountId = this.items_receive_cash[i].tafsili_list
          //       .filter(x => x.recId == this.items_receive_cash[i].selected_tafsili)[0].accountId
          // }
          if(obj.PayDesc == null && self.items_receive_cash[i].selected_doc_type==231){
            obj.PayDesc = self.$t('tables.off')
          }
          if (obj.MasterType == null) {
            obj.MasterType = 1;
          }
          if (obj.DocMasterId == null) {
            obj.DocMasterId = 0;
          }
          details.push(obj)
        }
      }
      if(details.length==0){
        return false;
      }
      var send_obj = {Master: master, Details: details}
      // console.log(JSON.stringify(send_obj))
      formData.append('model', JSON.stringify(send_obj));
      // formData.append('Details', JSON.stringify(details));
      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        if (res.data.statusCode == 0) {
          self.selected_payer_cash = null;
          self.selected_payer_cash_text = ""
          bus.$emit("update_add_receive", true);
          self.items_receive_cash = [{}]
          self.$root.modal_component.show_api_response_modals(res);
          self.get_invoice_remaining(self.factorMasterId);
        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    focus_reference(item, index) {
      this.selected_focus_reference = index
      console.log('selec_reference', index)
      this.selected_master_type_item = item.selected_master_type

    },
    get_banks() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.banks = content_data.data;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
        self.get_bank_names();

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank_names() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_names = [];
          self.bank_names = self.sort_array(
              self.bank_names, content_data.data,
              'id', 'bankTitle');

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
        self.get_cashiers();
      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_cashiers() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);

      axios.post('GetTafsiliesForCash', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.cashiers = content_data.data.filter(x=>x.isCashier==true);
          self.terminals = content_data.data.filter(x=>x.isCashier==false);
          self.selected_doc_type = 70;
          self.cashiers.filter(x => x.accountId == 70).forEach((val) => {
            var obj = {label: val.boxTitle, value: val.id,doc_type:70}
            self.payer_items_data.push(obj)
          });

          self.cashiers.filter(x => x.accountId == 288).forEach((val) => {
            var obj = {label: val.boxTitle, value: val.id,doc_type:288}
            self.payer_items_data.push(obj)
          });

          self.banks.forEach((val) => {
            var obj = {label: val.bankAccTitle, value: val.id,doc_type:74}
            self.payer_items_data.push(obj)
          });

          self.terminals.forEach((val) => {
            var obj = {label: val.boxTitle, value: val.id,doc_type:self.pos_id}
            self.payer_items_data.push(obj)
          });
          self.get_discounts()
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
        self.get_terminals();

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_discounts() {
      var self = this;

      const formData = new FormData();
      var url = "GetAccTafsilisByAccountId";
      let off_id  =231
      if(this.docType==1){
        off_id = 100

      }
      formData.append("accId", off_id);

      // formData.append("accId", this.selected_master_type);

      // self.tafzili_list = [];

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {

              content_data.data.forEach((val) => {
                var obj = {label: val.recTitle, value: val.recId,doc_type:off_id}
                self.payer_items_data.push(obj)
              });
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      ).catch(function (error) {
        console.log(error);
      });

    },
    get_invoice_report(item) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item.factorMasterId);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          self.items_invoice = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          self.items_invoice.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) > 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amountNegetive = 0
              val.amount = Math.abs(parseFloat(val.amount))
            }
            last_balance = val.balance;
          });
          self.invoice_info = true;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_invoice_remaining(item) {

      var self = this;
      var formData = new FormData();

      var url = "GetPersonAccountsByFactorId";

      // formData.append("FromDate", self.get_day_before_today_in_day(365));
      // formData.append("ToDate", self.get_today());
      formData.append('FactorId', item);
      // formData.append('FactorId', 3667);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {

          var items_invoice1 = content_data.data.personAccountItems.map((item, row_id) => {
            return {...item, row_id}
          });
          var last_balance = 0;
          items_invoice1.forEach(function (val) {
            val.balance = last_balance + parseFloat(val.amount);
            if (parseFloat(val.amount) > 0) {
              val.amountNegetive = Math.abs(parseFloat(val.amount))
              val.amount = 0;
            } else {
              val.amountNegetive = 0
              val.amount = Math.abs(parseFloat(val.amount))
            }
            last_balance = val.balance;
          });
          self.remaining_invoice = last_balance;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }

      })
          .catch(function (error) {

            console.log(error);
          });


    },
    get_person_remaining_amount(item) {
      var self = this;
      const formData = new FormData();

      formData.append('FromDate', moment().locale('en').format('YYYY-MM-DD'));
      formData.append('ToDate', moment().locale('en').format('YYYY-MM-DD'));


      // if(item.selected_doc_type==80){//customers
        formData.append('TafsiliType', 2);
      // }else if(item.selected_doc_type==163){//suppliers
      //   formData.append('TafsiliType', 3);
      // }else if (item.selected_doc_type == 70) {
      //   formData.append('TafsiliType', 6);
      // }else if (item.selected_doc_type == 288) {
      //   formData.append('TafsiliType', 7);
      // } else{
      //   formData.append('TafsiliType', 5);
      // }
      formData.append('id', 0);

      formData.append('PartyId', item);
      formData.append('ParentId', 10);
      formData.append('ChildId', 10);
      axios.post('GetLastPartyAccountByParam', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.remaining_person = response.data.data.balance

          // var items1 = content_data.data.personAccountItems.map((item, row_id) => {
          //   return {...item, row_id}
          // });
          // items1.forEach(function (val, index) {
          //   if (index == 0) {
          //     val.reminingBefore = 0;
          //     if (val.natureId == 0 && self.items[index + 1] != null) {
          //       val.natureId = self.items[index + 1].natureId;
          //     }
          //     // val.accBalance = val.accBalance
          //   } else {
          //     val.reminingBefore = self.items[index - 1].accBalance;
          //
          //     if (val.natureId == 2) {
          //       val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
          //       // val.accBalanceFinal =val.accBalance
          //       if (val.amount > 0) {
          //         val.amountNegetive = Math.abs(val.amount);
          //         val.amount = 0;
          //
          //       } else {
          //         val.amount = Math.abs(val.amount);
          //         val.amountNegetive = 0;
          //       }
          //     } else {
          //
          //       val.accBalance = parseFloat(val.reminingBefore) + parseFloat(val.amount);
          //       if (val.amount < 0) {
          //         val.amountNegetive = 0;
          //         val.amount = Math.abs(val.amount);
          //
          //       } else {
          //         val.amountNegetive = Math.abs(val.amount);
          //         val.amount = 0;
          //
          //       }
          //     }
          //   }
          //   self.remaining_person = items1[items1.length - 1].accBalance
            //
            // item.remaining

          // })
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },


  }
}

</script>
